module.exports = __webpack_public_path__ + "static/1-70d1e619bb44988ba3f16b0dada342d0.jpg";